import { useState } from "react";
import axios from "axios";
import useAxiosConfig from "../../../config/useAxiosConfig";

const useSendSchoolNotificationHook = (schoolId) => {
  const { loading: axiosLoading, error, postData: apiPost } = useAxiosConfig();
  const [loading, setLoading] = useState(true);

  const sendSchoolNotification = async (schoolId, subject) => {
    try {
      const response = await axios.put(
        `/SchoolNotificationMember/${schoolId}`,
        subject
      );
      return response.data;
    } catch (error) {
      console.error("Error Sending Notification:", error);
      throw error;
    }
  };

  return {
    loading,
    sendSchoolNotification,
  };
};
export default useSendSchoolNotificationHook;
